export default __webpack_public_path__ + "static/bdayCosmicBg-f9ef4c1a616597b5d90a76542434fcb4.jpg";